"use client";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { DailyReportRecord } from "@prisma/client";
import format from "date-fns/format";

const formatData = (data: DailyReportRecord[]) =>
  data.map((d) => ({
    date: format(d.createdAt, "d MMM yyyy"),
    "Post Total": d.postCount,
    "User Total": d.userCount,
    "Reaction From User Total": d.reactionFromUserCount,
    "Reaction From Guest Total": d.reactionFromAnonymousCount,
    "Reaction Total": d.reactionCount,
  }));

interface OpenLineChartProps {
  data: DailyReportRecord[];
}

export function OpenLineChart({ data }: OpenLineChartProps) {
  const formattedData = formatData(data);

  return (
    <div className="h-[500px] w-full py-16">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={500}
          data={formattedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Post Total" stroke="#31C48D" />
          <Line type="monotone" dataKey="User Total" stroke="#F98080" />
          <Line
            type="monotone"
            dataKey="Reaction From User Total"
            stroke="#E3A008"
          />
          <Line
            type="monotone"
            dataKey="Reaction From Guest Total"
            stroke="#1C64F2"
          />
          <Line type="monotone" dataKey="Reaction Total" stroke="#7E3AF2" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
